import { api } from './api';

export type Role = 'owner' | 'editor' | 'viewer';

export interface BoardSummary {
  id: string;
  title: string;
  role: Role;
  archived: boolean;
  assetCount: number | null;
  createdAt: string;
  updatedAt: string;
}

export const listBoards = () => api.get<{ boards: BoardSummary[] }>('/boards').then((r) => r.boards);
export const getBoard = (id: string) => api.get<{ board: BoardSummary }>(`/boards/${id}`).then((r) => r.board);
export const createBoard = (title: string) =>
  api.post<{ board: BoardSummary }>('/boards', { title }).then((r) => r.board);
export const updateBoard = (id: string, patch: { title?: string; archived?: boolean }) =>
  api.patch<{ board: BoardSummary }>(`/boards/${id}`, patch).then((r) => r.board);
export const deleteBoard = (id: string) => api.delete<{ ok: true }>(`/boards/${id}`);

export const createInvite = () => api.post<{ code: string; expiresAt: string }>('/invites');
export const listInvites = () =>
  api.get<{ invites: { code: string; expiresAt: string }[] }>('/invites').then((r) => r.invites);
